import { ExpressionEvaluatorFactory } from '../../expression-evaluator/factories/expressionEvaluatorFactory';
import {
  BinaryExpressionFactoryData,
  ExpressionEvaluatorType,
  UnaryExpressionFactoryData
} from '../../expression-evaluator/interfaces/expression-evaluator';
import { PrimitiveTypes } from '../../shared/interfaces/generics';
import { TemplateFormRenderExpression } from '../interfaces/template-form-render-expression';

export function TemplateFormRenderExpressionFactory(
  expression: TemplateFormRenderExpression | undefined
) {
  if (!expression) {
    return null;
  }

  const { type, left, right, operator, should_render: shouldRender } = expression;

  if ('should_render' in expression) {
    return ExpressionEvaluatorFactory({
      type: ExpressionEvaluatorType.LITERAL,
      value: !!shouldRender
    });
  }

  if (type === ExpressionEvaluatorType.UNARY_EXPRESSION && (left || right)) {
    let literalArgument: UnaryExpressionFactoryData['argument'];

    if (left) {
      literalArgument = {
        type: left.type,
        value: left.value as PrimitiveTypes
      };
    } else {
      literalArgument = {
        type: right!.type,
        value: right!.value as PrimitiveTypes
      };
    }

    return ExpressionEvaluatorFactory({
      type,
      operator,
      argument: literalArgument
    } as UnaryExpressionFactoryData);
  }

  if (type === ExpressionEvaluatorType.BINARY_EXPRESSION && left && right) {
    return ExpressionEvaluatorFactory({
      type,
      operator,
      left,
      right
    } as BinaryExpressionFactoryData);
  }

  return null;
}
